<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();
const items = computed(() =>
  (contentAttributes.value?.items || []).map(item => ({
    ...item,
    mediaUrl: item.mediaUrl || item.media_url,
  }))
);
</script>

<template>
  <div
    class="flex flex-col gap-2 w-full min-w-0 max-w-[min(42rem,calc(100vw-6rem))]"
  >
    <BaseBubble v-if="content" class="px-4 py-3" data-bubble-name="cards-text">
      <span
        v-dompurify-html="content"
        class="whitespace-pre-wrap"
        :title="content"
      />
    </BaseBubble>

    <div
      v-if="items.length"
      class="flex flex-row gap-3 overflow-x-auto overscroll-x-contain px-1 pb-2 -mx-1 w-full min-w-0 snap-x snap-mandatory"
      data-test-id="cards-carousel-lane"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex flex-col shrink-0 w-[17rem] max-w-[75vw] bg-white dark:bg-n-solid-3 border border-n-weak dark:border-n-strong rounded-xl overflow-hidden shadow-sm snap-start"
        data-test-id="cards-carousel-card"
      >
        <!-- Header Image -->
        <img
          v-if="item.mediaUrl"
          :src="item.mediaUrl"
          :alt="item.title || ''"
          class="w-full h-32 object-cover"
        />

        <!-- Body -->
        <div class="flex flex-col gap-1 p-3 grow">
          <span v-if="item.title" class="font-medium text-sm text-n-slate-12">
            {{ item.title }}
          </span>
          <span
            v-if="item.description"
            class="text-xs text-n-slate-11 line-clamp-3"
          >
            {{ item.description }}
          </span>
        </div>

        <!-- Actions -->
        <div
          v-if="item.actions && item.actions.length"
          class="flex flex-col border-t border-n-weak dark:border-n-strong"
        >
          <div
            v-for="(action, actionIndex) in item.actions"
            :key="actionIndex"
            class="flex items-center justify-center py-2.5 px-3 text-sm font-medium text-primary-500 hover:bg-n-alpha-1 cursor-pointer transition-colors"
            :class="{
              'border-t border-n-weak dark:border-n-strong': actionIndex > 0,
            }"
          >
            {{ action.text || action.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
